"use strict";
/**
 * Created on 07 22 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NotificationDocConverter_1 = require("../../../notifications/documents/NotificationDocConverter");
/**
 * <p>Serialization/deserialization of {@link MasterAreaDeactivatedNotification}.</p>
 *
 * @author JMe
 */


var MasterAreaDeactivatedNotificationConverter =
/*#__PURE__*/
function (_NotificationDocConve) {
  _inherits(MasterAreaDeactivatedNotificationConverter, _NotificationDocConve);

  function MasterAreaDeactivatedNotificationConverter() {
    _classCallCheck(this, MasterAreaDeactivatedNotificationConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(MasterAreaDeactivatedNotificationConverter).apply(this, arguments));
  }

  return MasterAreaDeactivatedNotificationConverter;
}(NotificationDocConverter_1.NotificationDocConverter);

exports.MasterAreaDeactivatedNotificationConverter = MasterAreaDeactivatedNotificationConverter;